import React from "react";
import mixinstyles from "../mixins.module.css";
import styles from "./ListItem.module.css";

type Alignment = "left" | "center" | "right";

/**
 * ListItem
 * @returns
 */
const ListItem = ({
  align,
  overrideContainerPadding,
  children,
}: React.PropsWithChildren<{ align?: Alignment, overrideContainerPadding?: boolean }>) => {
  return (
    <div
      role="listitem"
      className={`${styles.listitem} ${overrideContainerPadding ? styles.listitemoverridepadding : ''} ${mixinstyles["flexalignment" + (align ?? "left")]}`}
    >
      {children}
    </div>
  );
};

export default ListItem;
